import { connect } from "react-redux";
import Component from "./Transactions";

export default connect(
    null,
    ({ scp: { viewTransactions }, alert: { silence } }) => ({ viewTransactions, silence })
)(Component);
